import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';
import { compose } from 'ramda';

import { ContractRentSale, IContractRentSaleDispatch, IContractRentSaleProps } from './index';

import {
  contractRentSaleClearState,
  contractRentSaleSetError,
  submitSubscriptionContractRentSale,
} from '../../store/contract_rent_sale';
import { withEmptyRendering } from '../../utils/hoc';

type TShouldHideHOCProps = Pick<IContractRentSaleProps, 'category'>;

/**
 * скрываем контейнер, категория объекта - не квартира
 */
export function shouldHideContractRentSaleContainer(props: TShouldHideHOCProps) {
  return !props.category.toLowerCase().includes('flat');
}

function mapStateToProps(state: IState): IContractRentSaleProps {
  return {
    amount: state.offerData.offer.bargainTerms.prices.rur,
    category: state.offerData.offer.category,
    dealType: state.offerData.offer.dealType,
    messageError: state.contractRentSale.messageError,
    offer: state.offerData.offer,
    statusFetch: state.contractRentSale.statusFetch,
    user: state.offerData.user,
    ...state.mortgageMeta,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IContractRentSaleDispatch {
  return {
    contractRentSaleClearState: () => {
      dispatch(contractRentSaleClearState());
    },
    contractRentSaleSetError: () => {
      dispatch(contractRentSaleSetError('error', 'Не удалось отправить договор. Попробуйте еще раз.'));
    },
    submitSubscriptionContractRentSale: (host: string, email: string, docType: string, subscribeNews: boolean) => {
      dispatch(submitSubscriptionContractRentSale(host, email, docType, subscribeNews));
    },
  };
}

export const ContractRentSaleContainer = compose(
  connect<IContractRentSaleProps, IContractRentSaleDispatch>(mapStateToProps, mapDispatchToProps),
  withEmptyRendering(shouldHideContractRentSaleContainer),
)(ContractRentSale);
